import { CommonModule } from '@angular/common';
import { ElementRef } from '@angular/core';
import { UiFooterComponent, UiHeaderComponent, UiHeaderFooterBundle } from '../shared';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["*", [["ui-header"]], [["ui-footer"]]];
const _c1 = ["*", "ui-header", "ui-footer"];
function UiCardComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function UiCardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.header);
  }
}
function UiCardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.subheader);
  }
}
function UiCardComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
export let UiCardComponent = /*#__PURE__*/(() => {
  class UiCardComponent {
    set _size(val) {
      // fallback for discontinued size large
      if (val === 'large') this.size = 'medium';else this.size = val;
    }
    getCardClasses() {
      return 'ui-card p-component size-' + this.size + ' ' + this.styleClass + ' ' + 'box-' + this.theme + ' ' + (this.padding ? 'padded ' : '') + (this.linked ? 'linked ' : '');
    }
    constructor(el) {
      this.el = el;
      this.size = 'fullwidth';
      this.padding = true;
      this.theme = 'content';
      this.styleClass = '';
      this.linked = false;
      this.href = false;
    }
    getBlockableElement() {
      return this.el.nativeElement.children[0];
    }
    onClickCard() {
      if (this.href) window.location.href = this.href;
    }
    static {
      this.ɵfac = function UiCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiCardComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiCardComponent,
        selectors: [["ui-card"]],
        contentQueries: function UiCardComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiHeaderComponent, 5)(dirIndex, UiFooterComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerFacet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerFacet = _t.first);
          }
        },
        inputs: {
          header: "header",
          _size: [0, "size", "_size"],
          padding: "padding",
          subheader: "subheader",
          style: "style",
          theme: "theme",
          styleClass: "styleClass",
          linked: "linked",
          href: "href"
        },
        ngContentSelectors: _c1,
        decls: 8,
        vars: 6,
        consts: [[3, "click", "ngClass", "ngStyle"], [1, "ui-card-header"], [1, "ui-card-body"], [1, "ui-card-title"], [1, "ui-card-subtitle"], [1, "ui-card-content"], [1, "ui-card-footer"]],
        template: function UiCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function UiCardComponent_Template_div_click_0_listener() {
              return ctx.onClickCard();
            });
            i0.ɵɵconditionalCreate(1, UiCardComponent_Conditional_1_Template, 2, 0, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵconditionalCreate(3, UiCardComponent_Conditional_3_Template, 2, 1, "div", 3);
            i0.ɵɵconditionalCreate(4, UiCardComponent_Conditional_4_Template, 2, 1, "div", 4);
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(7, UiCardComponent_Conditional_7_Template, 2, 0, "div", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.getCardClasses())("ngStyle", ctx.style);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.headerFacet ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.header ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.subheader ? 4 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.footerFacet ? 7 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgStyle],
        styles: ["@layer primeng{.p-card-header[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}}[_nghost-%COMP%]{display:block;max-width:100%}.size-block[_ngcontent-%COMP%]{max-width:100%;width:1200px;margin:0 auto}.size-medium[_ngcontent-%COMP%]{max-width:100%;width:840px;margin:0 auto}.size-small[_ngcontent-%COMP%]{max-width:100%;width:400px;margin:0 auto}.ui-card[_ngcontent-%COMP%]{--padding: 20px;border-radius:var(--borderRadius);background:var(--contentColor);box-sizing:border-box;border:1px solid #c8c8c8;border-color:var(--panelContentBorderColor);box-shadow:0 1px 3px #0000001f}.ui-card.no-gutter[_ngcontent-%COMP%]{margin-bottom:0}.ui-card[_ngcontent-%COMP%]   .ui-card-body[_ngcontent-%COMP%], .ui-card[_ngcontent-%COMP%]   .ui-card-header[_ngcontent-%COMP%], .ui-card[_ngcontent-%COMP%]   .ui-card-footer[_ngcontent-%COMP%]{position:relative;padding:0}.ui-card.padded[_ngcontent-%COMP%]   .ui-card-body[_ngcontent-%COMP%]{padding:var(--padding)}.ui-card.padded[_ngcontent-%COMP%]   .ui-card-header[_ngcontent-%COMP%], .ui-card.padded[_ngcontent-%COMP%]   .ui-card-footer[_ngcontent-%COMP%]{padding:var(--padding) var(--padding) var(--padding)/2}.ui-card.padded[_ngcontent-%COMP%]   .ui-card-title[_ngcontent-%COMP%]{margin-bottom:20px}.ui-card.linked[_ngcontent-%COMP%]{transition:box-shadow .3s;display:block;cursor:pointer}.ui-card.linked[_ngcontent-%COMP%]:hover{box-shadow:0 5px 30px var(--boxHoverShadowColor)}[_nghost-%COMP%]    +ui-card>.ui-card{margin-top:20px}  ui-toolbar+ui-card>.ui-card{border-top-left-radius:0!important;border-top-right-radius:0!important}  .ui-grid>*>ui-card+ui-card>.ui-card{margin-top:25px}  .ui-grid-small>*>ui-card+ui-card>.ui-card{margin-top:10px}  .ui-grid-large>*>ui-card+ui-card>.ui-card{margin-top:40px}  .ui-grid-collapse>*>ui-card+ui-card>.ui-card{margin-top:0}  .ui-grid.match-height>*{display:flex;flex-direction:row}  .ui-grid.match-height>*>ui-card,   .ui-grid.match-height>*>ui-card>.ui-card,   .ui-grid.match-height>*>ui-card>.ui-card>.ui-card-body,   .ui-grid.match-height>*>ui-card>.ui-card>.ui-card-body .ui-card-content{display:flex;flex-direction:column;flex:1}"],
        changeDetection: 0
      });
    }
  }
  return UiCardComponent;
})();
export const UiCardBundle = [UiCardComponent, UiHeaderFooterBundle];